import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import DatePicker from 'components/sales/datePicker/datePicker';
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const ValetIncentiveFilter = ({
  applyFilter,
}) => {
  const parseLocalStorage = () => {
    try {
      const data = JSON.parse(window.localStorage?.filterDataIncentive || '{}');
      return {
        from_date: data.from_date || '',
        to_date: data.to_date || '',
        user_id: data.user_id || ''
      };
    } catch {
      return {
        from_date: '',
        to_date: '',
        user_id: ''
      };
    }
  };

  const initialFilterInputs = parseLocalStorage();

  const [filterFieldsData, setFilterFieldsData] = useState({
    from_date: initialFilterInputs.from_date,
    to_date: initialFilterInputs.to_date,
    user_id: initialFilterInputs.user_id
  });

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  useEffect(() => {
    const storedData = parseLocalStorage();
    setFilterFieldsData({
      from_date: storedData.from_date ? formatDate(storedData.from_date) : '',
      to_date: storedData.to_date ? formatDate(storedData.to_date) : '',
      user_id: storedData.user_id ? storedData.user_id : ''
    });
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter({
          to_date: filterFieldsData.to_date ? formatDate(filterFieldsData.to_date) : '',
          from_date: filterFieldsData.from_date ? formatDate(filterFieldsData.from_date) : '',
          user_id: filterFieldsData.user_id ? filterFieldsData.user_id : ''
        });
      }}
    >
      <DatePicker
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, from_date: val })
        }
        label="From Date"
        required={false}
        value={filterFieldsData.from_date}
      />
      <DatePicker
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, to_date: val })
        }
        label="To Date"
        required={false}
        value={filterFieldsData.to_date}
      />
      <ConstantInput
          label={"User ID"}
          value={filterFieldsData && filterFieldsData.user_id}
          type="number"
          handleChange={(val) => {
              setFilterFieldsData({ ...filterFieldsData, user_id: val });
          }}
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(initialFilterInputs);
            applyFilter({
              to_date: '',
              from_date: ''
            });
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default ValetIncentiveFilter;
